module.exports = __webpack_public_path__ + "static/media/the-three-amigos-deborah-shaw.de9c3f7c.jpg";